import { create } from "zustand";

import { Rolli } from "./useCheckInUIStore";

type DeliveryStore = {
  supplierId: string | null;
  externalSupplierId: string | null;
  deliveryTime: string | null;
  deliveryRollies: Rolli[];
};

const initialState: DeliveryStore = {
  supplierId: null,
  externalSupplierId: null,
  deliveryTime: null,
  deliveryRollies: [],
};

type DeliveryStoreWithMethods = DeliveryStore & {
  setDeliveryInfo(deliveryInfo: Partial<DeliveryStore>): void;
  reset(): void;
};

export const useDeliveryStore = create<DeliveryStoreWithMethods>()((set) => ({
  ...initialState,
  setDeliveryInfo({
    supplierId,
    externalSupplierId,
    deliveryTime,
    deliveryRollies,
  }: Partial<DeliveryStore>) {
    set((state) => ({
      ...state,
      supplierId: supplierId ?? state.supplierId,
      externalSupplierId: externalSupplierId ?? state.externalSupplierId,
      deliveryTime: deliveryTime ?? state.deliveryTime,
      deliveryRollies: deliveryRollies ?? state.deliveryRollies,
    }));
  },
  reset() {
    set({ ...initialState });
  },
}));
